import http from "../../plugins/axios";

export default {
    getTenantWalletList(data) {
        return http.get({
            url: `/la/admin/tenant/wallet/list`,
            data
        });
    },

    getWalletList(data) {
        return http.get({
            url: '/la/admin/tenant/wallet/type',
            data
        })
    },

    addTenantWallet(data) {
        return http.post({
            url: '/la/admin/tenant/wallet/add',
            data
        })
    },

    updaTenantWallet(data) {
        return http.post({
            url: `/la/admin/tenant/wallet/update`,
            data
        })
    },

};
